/* eslint-disable import/prefer-default-export */

/**
 * featuresBefore: [{ ... , plansDetails: { standard: 'Yes' , core: 'Yes' }}]
 * featuresAfter: [{ ... , fullrowLabel: 'Yes' }]
 */
export function makeFullRowIfSameStrings(features) {
  return features.map((feature) => {
    // ignore title labels
    if (feature.titleLabel) return feature;

    // if fullrowLabel - do nothing
    if (typeof feature.fullrowLabel === 'string') return feature;

    // create an array from plansDetails object
    const plansDetailsEntries = Object.entries(feature.plansDetails);

    // get first value from plansDetails to compare all other values with it
    const firstValue = plansDetailsEntries[0][1];

    // if this value is not a string - do nothing.
    if (typeof firstValue !== 'string') return feature;

    // if every value is the same as the first one - replace `plansDetails` with a `fullrowLabel`
    const isFullrow = plansDetailsEntries.every(([, value]) => value === firstValue);

    if (isFullrow) {
      return {
        label: feature.label,
        tooltipLabel: feature.tooltipLabel,
        fullrowLabel: firstValue,
      };
    }

    // otherwise - do nothing
    return feature;
  });
}
